import "./input-upload-file.scss";

import { Image } from "react-bootstrap";
import { FailureIcon, UploadIcon } from "src/assets";
import { InputUploadFileProps, SelectedDocumentRowProps } from "src/types";
import { ModalInfo, Separator, TranslationString } from "src/ui/widgets";

import { useInputUploadFile } from "./input-upload-file.hook";

import "./input-upload-file.scss";

export const InputUploadFile = (props: InputUploadFileProps) => {
  const {
    t,
    documents,
    confirmDeleteAlert,
    isOutOfSizeFile,
    isUploading,
    inputUploadFileRef,
    ACCEPTED_FILE_TYPES,
    documentToRemove,
    errorUplaodingFiles,
    hideErrorUplaodingFiles,
    handleDrop,
    confirmRemove,
    hideConfirmDeleteAlert,
    handleFileChange,
    setIsOutOfSizeFile,
    handleRemoveDocument,
  } = useInputUploadFile(props);

  return (
    <div id="file-upload">
      <div className="drag-drop">
        <div
          className="document-uploader border-neutral"
          onDrop={handleDrop}
          onDragOver={(event) => event.preventDefault()}
        >
          <div className="internal-box">
            <input
              ref={inputUploadFileRef}
              type="file"
              hidden
              id="browse"
              multiple
              onChange={handleFileChange}
              accept={ACCEPTED_FILE_TYPES}
              disabled={isUploading}
            />

            <Image
              src={UploadIcon}
              width={42}
              height={52}
              className="filter-f5bb78 mb-3"
            />

            <label
              htmlFor="browse"
              className="d-none d-md-block label-xl"
              style={{ cursor: isUploading ? "not-allowed" : "pointer" }}
            >
              <TranslationString
                i18nKey={"upload_file.upload_label_computer"}
                underline
              />
            </label>

            <label htmlFor="browse" className="d-block d-md-none">
              <TranslationString
                i18nKey={
                  isUploading
                    ? "upload_file.uploading"
                    : "upload_file.upload_label_mobile"
                }
              />
            </label>

            <div className="mt-2 text-muted" style={{ fontSize: "0.85rem" }}>
              {`DOCX, PDF, ${t("commons.images")}`}
            </div>
          </div>
        </div>
      </div>

      {documents?.length > 0 && (
        <div className="uploaded-file-list mt-3">
          {documents.map((document) => (
            <SelectedDocumentRow
              key={document.documentId}
              document={document}
              onRemove={handleRemoveDocument}
              deleteAriaLabel={t("commons.delete")}
            />
          ))}
        </div>
      )}

      <ModalInfo
        visible={isOutOfSizeFile}
        icon={FailureIcon}
        iconClasses=""
        message={t("commons.max_exceeded")}
        onClose={() => setIsOutOfSizeFile(false)}
      />

      <ModalInfo
        visible={confirmDeleteAlert && !!documentToRemove}
        icon={FailureIcon}
        iconClasses=""
        onClose={hideConfirmDeleteAlert}
        onConfirm={confirmRemove}
        message={t("upload_file.confirm_file_deleting", {
          file_name: documentToRemove?.fileName || "",
        })}
        confirmText={t("commons.confirm")}
      />

      <ModalInfo
        visible={errorUplaodingFiles}
        icon={FailureIcon}
        iconClasses=""
        onClose={hideErrorUplaodingFiles}
        message={t("upload_file.error_uploading_files")}
      />
    </div>
  );
};

const SelectedDocumentRow = ({
  document,
  onRemove,
  deleteAriaLabel,
}: SelectedDocumentRowProps) => {
  return (
    <div className="d-flex flex-column">
      <div className="d-flex align-items-center justify-content-between mb-2">
        <span className="uploaded-file-name" title={document.fileName}>
          {document.fileName}
          {/*document.fileSize && (
          <span className="text-muted"> ({document.fileSize})</span>
        )*/}
        </span>

        <button
          type="button"
          className="btn-close"
          aria-label={deleteAriaLabel}
          onClick={(e) => {
            e.currentTarget.blur();
            onRemove(document);
          }}
          style={{
            fontSize: "0.75rem",
            padding: "0.25rem 0.5rem",
          }}
        />
      </div>
      <Separator classes="border-4 br-primary" />
    </div>
  );
};
